import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { DetailsCardFooter, Grid, Typography, useThemedValueSwitch } from '@tq/ui-components';

import { isRpc } from 'tools';
import {
  CARD_LEFT_PADDING_SIZE,
  ROW_TEMPLATE_COLUMNS_DESKTOP,
  CARD_RIGHT_PADDING_SIZE,
} from '../../constants';
import { renderCardLabelledValue } from '../../util';
import { ConsultationCardProps } from '../../types';

export const ConsultationCardFooter: React.FC<ConsultationCardProps> = ({
  consultation,
  isHighlighted,
}) => {
  const { t } = useTranslation('consultation_card');
  const { tvs } = useThemedValueSwitch();

  const defaultFooterColor = tvs({ tq: 'grey.50' }, COLOURS.gray[200]);
  const rpcFooterColor = tvs({ tq: 'blue.50' }, COLOURS.blue[100]);

  const backgroundColour = () => {
    if (isHighlighted) {
      return 'unset';
    }

    return isRpc(consultation) ? rpcFooterColor : defaultFooterColor;
  };

  return (
    <DetailsCardFooter
      backgroundColor={backgroundColour()}
      pr={CARD_RIGHT_PADDING_SIZE}
      py={3}
      data-testid='consultation-card-footer'
    >
      <Grid
        ml={{ base: undefined, lg: CARD_LEFT_PADDING_SIZE }}
        gridTemplate={{
          base: undefined,
          lg: isRpc(consultation)
            ? `"assignee type ." / ${ROW_TEMPLATE_COLUMNS_DESKTOP}`
            : `"assignee type category" / ${ROW_TEMPLATE_COLUMNS_DESKTOP}`,
        }}
        justifyContent='space-between'
        flexWrap='nowrap'
        gridGap={{ base: 3, lg: 0 }}
      >
        {renderCardLabelledValue(t('assignee', 'Assignee'), consultation.assignee ?? '-')}

        {renderCardLabelledValue(
          t('consultationType', 'Consultation type'),
          consultation.consultationType
        )}
        {isRpc(consultation) ? null : (
          <Typography justifySelf={{ base: 'flex-start', lg: 'flex-end' }}>
            <strong>{t('category', 'Category')}</strong>: <span>{consultation.category}</span>
          </Typography>
        )}
      </Grid>
    </DetailsCardFooter>
  );
};
